import { Controller } from "react-hook-form";
import Icon from "../Icon/Icon";

interface SliderInputProps {
  name: string;
  label: string;
  icon: string;
}
export const SliderInput = (props: SliderInputProps) => {
  const { name, label, icon } = props;
  return (
    <Controller
      name={name}
      render={({ field }) => {
        return (
          <div className="flex flex-col gap-1 min-w-full">
            <label htmlFor={label}>{label}</label>
            <div className="grid grid-cols-12 gap-4 min-w-full items-center text-sm">
              <input
                style={{
                  background: `linear-gradient(to right, var(--color-primary-500) ${field.value}%, var(--color-white-500) ${field.value}%)`,
                }}
                className="col-span-10 min-w-full range-slider cursor-pointer"
                type="range"
                min="1"
                max="100"
                value={field.value}
                onChange={(event) => field.onChange(Number(event.target.value))}
              />
              <div className="col-span-2 flex items-center justify-center bg-primary-700 gap-1 text-primary-300 border border-primary-300 max-w-fit px-2 py-1 rounded-md">
                <Icon name={icon} size={16} />
                {field.value}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};
